'use client';

import React, { useState } from 'react';
import { SlLocationPin } from 'react-icons/sl';

export default function AccordionSinglePost({ active = '', data }) {
    const [isOpen, setIsOpen] = useState(active !== '');

    return (
        <div className="mb-4 rounded-xl border border-indigo-50">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="inline-flex gap-x-3 justify-between items-center p-2 w-full font-semibold text-gray-700 bg-gray-100 rounded-lg border border-gray-200 text-start hover:text-gray-700 dark:border-neutral-700 dark:bg-neutral-700 dark:text-gray-200 dark:hover:text-gray-400 dark:focus:outline-none dark:focus:text-white"
                aria-expanded={isOpen}
                aria-controls={`accordion-collapse-${data.id}`}
            >
                <div className="flex gap-4 items-center">
                    <div className="flex gap-2 items-center px-3 py-1 text-sm text-white rounded-md min-w-fit bg-main-color">
                        <SlLocationPin className="hidden lg:inline-block" />
                        {data.name}
                    </div>
                    {data.title}
                </div>
                <svg
                    className={`size-4 transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="m6 9 6 6 6-6" />
                </svg>
            </button>

            <div
                id={`accordion-collapse-${data.id}`}
                role="region"
                aria-labelledby={`accordion-heading-${data.id}`}
                style={{ maxHeight: isOpen ? '2000px' : '0', opacity: isOpen ? 1 : 0 }}
                className="overflow-hidden transition-all duration-300 ease-in-out"
            >
                <div className="p-6 custom-text-base" dangerouslySetInnerHTML={{ __html: data.description }} />
            </div>
        </div>
    );
}
